import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CANCEL_TOOLTIP_CONTENT = (
    <FormattedMessage
        id='production_progress.cancel_tooltip_content'
        defaultMessage='Нажмите, чтобы отменить подготовку резервов.{newLine}Затраченный на подготовку промресурс будет возвращён на склад.' // eslint-disable-line max-len
        values={{
            newLine: <br/>,
        }}
    />
)

export const ADD_RESERVE_TO_QUEUE_TITLE = (
    <FormattedMessage
        id='building_reserve_produce.add_reserve_to_queue_title'
        defaultMessage='Добавить к подготовке'
    />
)

export const CANCEL_TOOLTIP_ID = 'production_progress.cancel_tooltip'



// WEBPACK FOOTER //
// ./components/ProductionProgress/constants.jsx